// extracted by mini-css-extract-plugin
export default {"header":"DuCnvtyJdJiPrLStePwv3A=="};